<template>
  <a-modal title="保存prompt组合" v-model="visible" width="440px" @ok="save" @cancel="onClose" :maskClosable="false">
    <div style="display: flex; align-items: center">
      prompt组合名称：
      <a-input v-model.trim="form.promptCombinationName" placeholder="请输入prompt组合名称" style="width: 70%" />
    </div>
  </a-modal>
</template>

<script>
import { Sketch } from 'vue-color';
import _ from 'lodash';

export default {
  components: { Sketch },
  data() {
    return {
      visible: false,
      form: {
        promptCombinationName: '',
      },
      type: '',
    };
  },
  methods: {
    openModal(data, type) {
      Object.assign(this.$data, this.$options.data());
      this.form = _.cloneDeep(data);
      this.type = type;
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    save() {
      if (!this.form.promptCombinationName) {
        this.$message.warning('prompt组合名称不能为空!');
        return;
      }
      this.$emit('success', this.form, this.type);
      this.onClose();
    },
  },
  created() {},
};
</script>

<style scoped lang="scss"></style>
